import { useTheme } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Blocked = () => {
  var {
    colors
  } = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    height: "100%",
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M124 72C124 100.719 100.719 124 72 124C43.2812 124 20 100.719 20 72C20 43.2812 43.2812 20 72 20C100.719 20 124 43.2812 124 72ZM110.316 71.9992C110.316 93.1605 93.1613 110.315 72 110.315C64.7601 110.315 57.9892 108.307 52.2138 104.818L104.818 52.213C108.308 57.9883 110.316 64.7593 110.316 71.9992ZM91.9486 39.2795C86.1379 35.7293 79.3079 33.6834 72 33.6834C50.8388 33.6834 33.6843 50.838 33.6843 71.9992C33.6843 79.3071 35.7301 86.1371 39.2803 91.9478L91.9486 39.2795Z",
      fill: colors.illustration.critical
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 72C18 42.1766 42.1766 18 72 18C101.823 18 126 42.1766 126 72C126 101.823 101.823 126 72 126C42.1766 126 18 101.823 18 72ZM72 22C44.3858 22 22 44.3858 22 72C22 99.6142 44.3858 122 72 122C99.6142 122 122 99.6142 122 72C122 44.3858 99.6142 22 72 22ZM31.6843 71.9992C31.6843 49.7334 49.7342 31.6834 72 31.6834C79.6862 31.6834 86.8756 33.8363 92.9913 37.5729L95.1592 38.8974L38.8982 95.1583L37.5737 92.9905C33.8371 86.8748 31.6843 79.6854 31.6843 71.9992ZM72 35.6834C51.9434 35.6834 35.6843 51.9426 35.6843 71.9992C35.6843 78.0124 37.1442 83.6799 39.7284 88.6713L88.6721 39.7276C83.6808 37.1434 78.0132 35.6834 72 35.6834ZM105.21 48.9932L106.53 51.1787C110.203 57.2573 112.316 64.3846 112.316 71.9992C112.316 94.265 94.2658 112.315 72 112.315C64.3854 112.315 57.2582 110.202 51.1795 106.529L48.994 105.209L105.21 48.9932ZM55.5003 104.359C60.4495 106.888 66.0559 108.315 72 108.315C92.0567 108.315 108.316 92.0559 108.316 71.9992C108.316 66.0551 106.889 60.4487 104.36 55.4994L55.5003 104.359Z",
      fill: colors.illustration.stroke
    })]
  });
};
//# sourceMappingURL=Blocked.js.map